<template>
    <v-menu
            left bottom
    >
        <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
        </template>

        <v-list >
            <v-list-item v-if="showGoToPVBtn" @click="sendToPoslogValidation(xml)">
                <v-list-item-icon>
                    <v-icon>mdi-check-circle-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>Go to Poslog Validation</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="showXmlBtn" @click="moveTo('xml', anonymized, messageDateTime, version)">
                <v-list-item-icon>
                    <v-icon>mdi-xml</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>Show XML</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="showJsonBtn" @click="moveTo('json', anonymized, messageDateTime, version)">
                <v-list-item-icon>
                    <v-icon>mdi-code-braces</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>Show JSON</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="showReceiptBtn" @click="moveTo('receipt', anonymized, messageDateTime, version)">
                <v-list-item-icon>
                    <v-icon>mdi-receipt</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>Show Receipt</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="showDownloadBtn" @click="download">
                <v-list-item-icon>
                    <v-icon>mdi-download</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>Download</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="showRawBtn" @click="moveTo(currentView, false, messageDateTime, version)">
                <v-list-item-icon>
                    <v-icon>mdi-eye</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>Display Raw Poslog</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="showAnonymizedBtn" @click="moveTo(currentView, true, messageDateTime, version)">
                <v-list-item-icon>
                    <v-icon>mdi-eye-off</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>Display Anonymized Poslog</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="showHistoryBtn" @click="moveTo('history', anonymized, messageDateTime, version)">
                <v-list-item-icon>
                    <v-icon>mdi-history</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>Show history</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import {TRANSACTION_NS} from "@/store/modules/transaction/constants";
    import {downloadData} from "@/requesters/utils";
    import {parameters} from "@/parameters";

    export default {
        name: "TransactionMenu",
        computed: {
            ...mapGetters(TRANSACTION_NS, [
                'transactionId',
                'messageDateTime',
                'version',
                'currentView',
                'anonymized',
                'poslogApi',
                'downloadMeta',
                'content',
                'xml',
                'receipt'
            ]),
            isShowingCode() {
                return this.currentView == "xml" || this.currentView == "json" || this.currentView == "receipt";
            },
            showGoToPVBtn() {
                return this.currentView == "xml";
            },
            showXmlBtn() {
                return this.currentView != "xml";
            },
            showJsonBtn() {
                return this.currentView != "json";
            },
            showReceiptBtn() {
                return this.currentView != "receipt" && this.receipt != "";
            },
            showDownloadBtn() {
                return this.isShowingCode;
            },
            showAnonymizedBtn() {
                return this.isShowingCode && !this.anonymized;
            },
            showRawBtn() {
                return parameters.showRawData && (this.isShowingCode && this.anonymized);
            },
            showHistoryBtn() {
                return this.currentView != "history";
            }
        },
        methods: {
            ...mapActions(TRANSACTION_NS, [
                'sendToPoslogValidation'
            ]),
            moveTo: function(view, anonymized, messageDateTime, version) {
                this.$router.replace({
                    name: 'transactionView',
                    params: {
                        'transactionId': this.transactionId,
                        view,
                        messageDateTime,
                        version,
                        anonymized: anonymized ? 'anonymized' : 'raw'
                    }
                });
            },
            download() {
                downloadData(
                    `${this.transactionId}.${this.downloadMeta.ext}`,
                    this.downloadMeta.contentType,
                    this.content
                );
            }
        }
    }
</script>